export interface SettingsPageProps {}


export const NUMERIC_SETTINGS_KEYS = [
  'visibility', 'windGust', 'windSpeed',
  'deliveryAltitude', 'deliverySpeed', 'flightAltitude', 
  'deliveryRadius', 'updateFrequency', 'geofenceWidth', 
  'failSafe', 'altitude', 'speed', 'minReturnAltitude',
];